import React from "react";

import { bounceInUp, fadeOutDown } from "react-animations";
import { StyleSheet, css } from "aphrodite";

const animate = StyleSheet.create({
  init: {
    animationName: bounceInUp,
    animationDuration: "1.5s",
  },
  out: {
    animationName: fadeOutDown,
    animationDuration: "1.5s",
  },
});

class TransitionWrap extends React.Component {
  render() {
    if (this.props.type === "out")
      return <div className={css(animate.out)}>{this.props.children}</div>;

    // pop in bounce (first animation)
    return <div className={css(animate.init)}>{this.props.children}</div>;
  }
}

export default TransitionWrap;
